module.exports = __webpack_public_path__ + "img/user-bg.008e9286.jpg";